import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

// Lazy store resolution: a module-scope import here closes a cycle
// (stores -> components -> mixins -> classes). See scripts/find-import-cycles.py.
// eslint-disable-next-line global-require
const useGeneralStore = (...args) => require("%/dynamic-component-editor/stores/general-store").useGeneralStore(...args);
// eslint-disable-next-line global-require
const useFanPublicationStore = (...args) => require("%/dynamic-component-editor/stores/fan-publication-store").default(...args);


export default class ProductLinkCollection extends BaseOption {
  static label = "Collection";

  static userInterfaceComponent = () => {
    return {
      component: inspectorTools.AUTOCOMPLETE,
      props: {
        showAllResultsOnClick: true,
        isAsync: true,
        sourceUrl: () => {
          return useGeneralStore().links.api + `/affiliate-link-collection/${useFanPublicationStore().publicationId}/search`;
        },
        itemValueKey: "value",
        itemLabelKey: "label",
        placeholder: "Search collections",
        runInitialSearch: true,
      },
    };
  };

  static defaultValue = "";
}
